import { render, staticRenderFns } from "./table_service_card.vue?vue&type=template&id=5f59fbb1&scoped=true"
import script from "./table_service_card.vue?vue&type=script&lang=js"
export * from "./table_service_card.vue?vue&type=script&lang=js"
import style0 from "./table_service_card.vue?vue&type=style&index=0&id=5f59fbb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f59fbb1",
  null
  
)

export default component.exports